<ion-grid
  fixed="true"
  class="ion-padding-vertical-0"
>
  <ion-row>
    <ion-col size="12">
      <div class="card-buttons">
        <div class="card-buttons--start">
          <lib-freight-documentation-links [freight]="freightBasic()"></lib-freight-documentation-links>
        </div>

        <div class="card-buttons--end">
          <lib-incidence-button [reference]="freightBasic().reference"></lib-incidence-button>
        </div>
      </div>
      @if (canInteractWithStops() && isStopButtonActive()) {
        <lib-freight-carrier-stop-button [freight]="freightBasic()"></lib-freight-carrier-stop-button>
      }
    </ion-col>
  </ion-row>
</ion-grid>
